module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAASCAYAAABfJS4tAAABXElEQVQ4jZ2UMUuDMRCG30oFEQsKKuoPUCo4CBbF1dlN3EXwD7j5ExRddHBwc/IXaKGIg0PBwblTEaS0IoqItVrr4/C1kKaXr7UvHOEuuScJd4kAGTYHXACPwAdwA6wH1ppmBReBdzr1BqwASWAemPovOGdA88AMsAe8OvEisNEr+MuDVoFp4MjYEOAX2OwGThmJl8AEUA+AAQo+eEDtaqhTJUkZSUljrqVZSSk34IOrkspe7FnSeAy0pbE4sCTlPH9QUq0HcNttLfChpB/HT0sqdIF+Sqq0RaxWAU6cwtSASeAhpnjZbl3Rsi0v8QzYDkDrQKYX8DBw6yU3iFrxzgAfWIdznRFgJ3DlJ6KnfG7MpUPgFLBP9BdYKgFrwEJgzSmQsMDZALAI7BJ9PMd0PnVXOWDVB5eBF8fKTeAScB0Ds3RPVOShBGD15aikYnPsR1ch8LKkfJ9QSfr+A+5aslYXbRq2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/master/ico1.png
// module id = /srB
// module chunks = 11